module.exports = __webpack_public_path__ + "static/media/thumb.501986d5.jpg";